import { CapaQuotationServiceType } from '@generated/graphql';
import CastingArray from './CastingArray';
import CNCArray from './CNCArray';
import MoldingArray from './MoldingArray';
import PrintingArray from './PrintingArray';
import SheetMetalArray from './SheetMetalArray';

export default (serviceType?: CapaQuotationServiceType) => {
  if (serviceType === CapaQuotationServiceType.Cnc) return CNCArray;
  if (serviceType === CapaQuotationServiceType.Printing) return PrintingArray;
  if (serviceType === CapaQuotationServiceType.Inj) return MoldingArray;
  if (serviceType === CapaQuotationServiceType.SheetMetal)
    return SheetMetalArray;
  if (serviceType === CapaQuotationServiceType.Casting) return CastingArray;

  return [];
};
